module.exports = __webpack_public_path__ + "assets/99e4a4723c8252d24dc77a8c3d882c3f.json";